import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { ItemsSize } from '../ItemsSize'
import { Material } from 'container/SalesOrder/interfaces'
import * as S from './styles'
import { useSelector } from 'store/store'
import { TypesValidations } from 'constants/enums'

type ItemMaterialDetailsProps = {
  material: Material
}

const ItemMaterialDetails = ({ material }: ItemMaterialDetailsProps) => {
  const methods = useFormContext()

  const { records } = useSelector((store) => store.salesOrder)

  const getItemCustomFlag = (itemNumber: number) => {
    const record = records.find((item) => item.nr_item_pedi_rasc === itemNumber)
    if (record) return record.fl_caix_grad === TypesValidations.YES
    return false
  }

  const getItemCustomBoxAmount = (itemNumber: number) => {
    const record = records.find((item) => item.nr_item_pedi_rasc === itemNumber)
    if (record) return record.qt_caix_grad
    return 0
  }

  useEffect(() => {
    const defaultT: Record<string, number[]> = material.cores.reduce(
      (acc, key) => ({
        ...acc,
        [key.ds_cor]: key.tamanhos.map((tamanho) => {
          return tamanho.qt_item
        })
      }),
      {}
    )

    for (const key in defaultT) {
      defaultT[key]?.forEach((tamanho, index) => {
        if (tamanho > 0) {
          methods.setValue(`[${key}][${index}]`, tamanho)
        }
      })
    }
  }, [material])

  return (
    <S.ContentColor>
      {material.cores.map((color) => (
        <ItemsSize
          key={color.ds_cor}
          color={color}
          isGrade={!!material?.cores[0]?.tamanhos[0]?.cd_tamh?.match(/\D/g)}
          cd_matr={material.cd_matr}
          quantConv={material.qt_item_conv}
          materialStatus={material.stat}
          isCustom={getItemCustomFlag(material.nr_item_pedi_rasc)}
          customBoxAmount={getItemCustomBoxAmount(material.nr_item_pedi_rasc)}
          pairsAmount={color.qt_tota_pars ?? material.qt_item_conv}
        />
      ))}
    </S.ContentColor>
  )
}

export default ItemMaterialDetails
